const GHOST = 'rounded bg-gray-200';
const CARD =
  'flex flex-col gap-4 rounded-2xl border border-gray-100 bg-white p-5';

/**
 * The statistics while their figures load: the banner, the cards and the
 * chart drawn in grey where they will land, so nothing jumps.
 */
const StatsSkeleton = () => (
  <div className="flex animate-pulse flex-col gap-6" aria-busy="true">
    <div className="flex min-h-[146px] items-center gap-4 rounded-2xl bg-gray-100 p-4">
      <span className="flex flex-1 flex-col gap-3">
        <span className={`h-5 w-1/3 ${GHOST}`} />
        <span className={`h-3.5 w-1/2 ${GHOST}`} />
        <span className={`h-3.5 w-40 ${GHOST}`} />
      </span>
      <span className="size-[76px] shrink-0 rounded-full border-8 border-gray-200" />
    </div>
    <div className={CARD}>
      <span className={`h-4 w-24 ${GHOST}`} />
      {[92, 64, 40, 18].map((width) => (
        <div key={width} className="flex items-center gap-4">
          <span className={`h-3.5 w-[110px] shrink-0 tab:w-[170px] ${GHOST}`} />
          <span className="h-2.5 flex-1 rounded-[5px] bg-gray-100">
            <span
              className="block h-full rounded-[5px] bg-gray-200"
              style={{ width: `${width}%` }}
            />
          </span>
          <span className={`h-3.5 w-8 ${GHOST}`} />
        </div>
      ))}
      <div className="grid grid-cols-2 gap-3 tab:grid-cols-4">
        {[1, 2, 3, 4].map((tile) => (
          <span
            key={tile}
            className="h-[68px] rounded-[14px] border border-gray-100"
          />
        ))}
      </div>
    </div>
    <div className={CARD}>
      <span className={`h-4 w-20 ${GHOST}`} />
      <div className="grid grid-cols-2 gap-3 tab:grid-cols-3 xl:grid-cols-6">
        {[1, 2, 3, 4, 5, 6].map((tile) => (
          <span
            key={tile}
            className="h-[118px] rounded-2xl border border-gray-100"
          />
        ))}
      </div>
    </div>
    <div className="flex flex-col gap-6 lg:flex-row">
      <div className={`${CARD} min-w-0 flex-1`}>
        <span className={`h-4 w-48 ${GHOST}`} />
        <div className="flex min-h-[188px] items-end gap-4">
          {[40, 75, 55, 90, 30].map((height, index) => (
            <span key={index} className="flex flex-1 justify-center">
              <span
                className="w-8 rounded-t-md bg-gray-200"
                style={{ height }}
              />
            </span>
          ))}
        </div>
      </div>
      <div className={`${CARD} w-full lg:w-[344px]`}>
        <span className={`h-4 w-28 ${GHOST}`} />
        {[1, 2, 3, 4].map((row) => (
          <span key={row} className={`h-3.5 w-full ${GHOST}`} />
        ))}
      </div>
    </div>
  </div>
);

export default StatsSkeleton;
